export interface IDriversLicenseLookupOptions {
  DriversLicenseFieldName: string;
  showButton: boolean;
  overrideExistingValues: boolean;
  fieldValueMaps: IDriversLicenseLookupValueMap[];
}

export interface IDriversLicenseLookupValueMap {
  modelFieldName: string;
  lookupFieldName: string;
  lookupFieldType: DriversLicenseLookupValueFieldType;
  codeTranslations?: ILookupCodeTranslation[];
}

export interface ILookupCodeTranslation {
  lookupValue: string;
  outputValue: string;
}

export enum DriversLicenseLookupValueFieldType {
  Code = 'code',
  Description = 'description',
}

export interface DmvVehicleData {
  RecordCount?: number;
  ResultsLimited?: boolean;
  Record?: Record;
}

export interface Record {
  RecordSequence?: number;
  VictoryVehicleID?: string;
  Vehicle?: DmvVehicle;
  ID?: Id;
}

export interface Id {
  VehicleID?: string;
  Type?: string;
}

export interface DmvVehicle {
  Type?: string;
  TypeDecode?: string;
  Year?: number;
  Make?: string;
  Model?: string;
  MakeCategory?: string;
  MakeDescription?: string;
  MakeNcic?: string;
  PrimaryColor?: string;
  SecondaryColor?: string;
  FuelType?: string;
  FuelTypeDecode?: string;
  Gvw?: number;
  UnladenWeight?: number;
  WeightRating?: string;
  BodyStyle?: string;
  BodyStyleDecode?: string;
  BodyStyleNcic?: string;
  VinVerified?: number;
  Capacity?: number;
  Msrp?: string;
  VehicleRegistrationYear?: number;
}
